import { render, staticRenderFns } from "./Comp1t3.vue?vue&type=template&id=7d784490&scoped=true&"
import script from "./Comp1t3.vue?vue&type=script&lang=js&"
export * from "./Comp1t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp1t3.vue?vue&type=style&index=0&id=7d784490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d784490",
  null
  
)

export default component.exports